import script from "./InformationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationCard.vue?vue&type=script&setup=true&lang=js"

import "./InformationCard.vue?vue&type=style&index=0&id=0089676a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0089676a"]])

export default __exports__